import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  if (!date) return "-";

  let parsedDate = new Date(date);

  if (typeof date === 'string') {
    const match = date.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (match) {
      const [, day, month, year] = match;
      parsedDate = new Date(year, parseInt(month) - 1, day);
    }
  }

  if (isNaN(parsedDate.getTime())) return "-";

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(parsedDate);
}

export function formatDateTime(date) {
  if (!date) return "-";

  let parsedDate = new Date(date);

  if (typeof date === 'string') {
    const match = date.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (match) {
      const [, day, month, year] = match;
      parsedDate = new Date(year, parseInt(month) - 1, day);
    }
  }

  if (isNaN(parsedDate.getTime())) return "-";

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  }).format(parsedDate);
}

/**
 * Determines whether a store is configured to charge sales tax.
 * A store charges sales tax when:
 * 1. Default tax class is configured (not empty, and not "none" / "na").
 * 2. Tax percentage is greater than 0.
 *
 * @param {object} store - Store configuration object
 * @returns {boolean}
 */
export function isStoreChargingTax(store) {
  if (!store) return false;
  const taxClass = (store.default_tax_class || store.tax_class || "").trim().toLowerCase();
  const isTaxClassConfigured = taxClass !== "" && taxClass !== "none" && taxClass !== "na";
  const taxRate = parseFloat(store.tax_percentage) || 0;
  return Boolean(isTaxClassConfigured && taxRate > 0);
}
